export enum FlexMemberTableSource {
    PROJECT_DASHBOARD = 'project',
    MEMBER_DASHBOARD = 'member',
}
